var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9953 15.9991C31.9953 24.7924 24.8671 31.9206 16.0738 31.9206C7.28054 31.9206 0.152344 24.7924 0.152344 15.9991C0.152344 7.20583 7.28054 0.0776367 16.0738 0.0776367C24.8671 0.0776367 31.9953 7.20583 31.9953 15.9991",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0738 18.6639L13.4089 15.9991L16.0738 13.3342L18.7387 15.9991L16.0738 18.6639ZM22.1298 15.9991L22.1185 16.0103L24.5902 18.4818L27.0729 15.9991L24.5731 13.4992L22.1014 15.9707L22.1298 15.9991Z",
    fill: "#F4BB0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7906 14.2263L16.0739 9.94305L20.4201 14.2893L22.8915 11.8179L16.0739 5L9.31909 11.7548L11.7906 14.2263ZM20.4372 17.6917L16.0739 22.055L11.7492 17.7302L9.27767 20.2018L16.0739 26.9981L22.9087 20.1632L20.4372 17.6917ZM10.018 15.999L10.1093 15.9078L7.63759 13.4361L5.07495 15.999L7.59631 18.5204L10.0677 16.0489L10.018 15.999Z",
    fill: "#F4BB0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/BNB.6334e9f560649373d466247861074dd5.svg";
export { ForwardRef as ReactComponent };